import L from "leaflet";
import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box } from "@mui/material";
import { titleCase } from "title-case";

const weighstationIcons = {
  open:
    process.env.PUBLIC_URL + "/mapicons/WeighStation/Weigh_Station_Open_2.png",
  closed:
    process.env.PUBLIC_URL + "/mapicons/WeighStation/Weigh_Station_Closed.png",
  unknown:
    process.env.PUBLIC_URL + "/mapicons/WeighStation/Weigh_Station_Unknown.png",
};

const getWeighStationIconUrl = (feature) => {
  if (feature.properties.open === "Yes") {
    return weighstationIcons["open"];
  } else if (feature.properties.open === "No") {
    return weighstationIcons["closed"];
  } else {
    return weighstationIcons["unknown"];
  }
};

var weighstationIcon = (feature) =>
  L.icon({
    iconUrl: getWeighStationIconUrl(feature),
    iconSize: [25, 25], // size of the icon
    popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
  });

const getLeafletIcon = (feature, latlng, map, pane) => {
  var title = "  Weigh Station - " + getStatus(feature.properties);
  return L.marker(latlng, {
    icon: weighstationIcon(feature),
    title: title,
    alt: title,
    pane: pane,
  });
};

const getStatus = (properties) => {
  return properties.name + " - " + properties.address;
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  return <WeighStation feature={feature} />;
};

const WeighStation = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  const avtSrc = getWeighStationIconUrl(feature);
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="Weigh Station"
            src={avtSrc}
            sx={{ width: 21, height: 21 }}
            aria-label="WeighStation"
          ></Avatar>
        }
        title={<font className="layer-title"> Weigh Station </font>}
        sx={{ pb: 0, paddingTop: 1, paddingLeft: 1 }}
        className={"styledtablerow"}
      />

      <CardContent
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <Table size="small">
          <TableRow>
            <TableCell className={"layertablecellLeft"} colSpan={2}>
              <div>{properties.name}</div>
              {`${properties.address}`}
            </TableCell>
          </TableRow>
          <TableRow className={"styledtablerow"}>
            <TableCell className={"layertablecellLeft"}>Description</TableCell>
            <TableCell className={"layertablecellRight"}>
              {properties.description}
            </TableCell>
          </TableRow>
          {(properties.open === "Yes" || properties.open === "No") && (
            <TableRow>
              <TableCell className={"layertablecellLeft"}>Open</TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.open}
              </TableCell>
            </TableRow>
          )}
        </Table>
      </CardContent>
    </Card>
  );
};

const LegendTemplate = (props) => {
  return (
    <Box sx={{ display: "inline-list-item", height: "50px" }}>
      {Object.keys(weighstationIcons).map((key, index) => {
        let image = weighstationIcons[key];
        return (
          <Box sx={{ ml: 8, mr: -8, display: "inline-list-item" }} key={key}>
            <Box
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "contain",
                width: "20px",
                backgroundRepeat: "no-repeat",
              }}
            ></Box>
            <Box sx={{ mr: 1, ml: 1, fontSize: 12 }}>{titleCase(key)}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

const module = {
  name: "Weigh Stations",
  endpoint: "/weighStationMap.json",
  showOnMap: true,
  getLeafletIcon: getLeafletIcon,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/WeighStation/Weigh_Station_Open_2.png",
  LegendTemplate: LegendTemplate,
  maxZoom: 5,
  zIndex: 615,
};

export default module;
